import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './CreateButton.scss';
const CreateButton = (_param)=>{
    var { className, children, icon: IconComponent, loading } = _param, props = _object_without_properties(_param, [
        "className",
        "children",
        "icon",
        "loading"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: classnames(className, s['root'], props.disabled && s['disabled'], loading && s['loading'], IconComponent && s['with-prefix-icon'])
    }, props), IconComponent && /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['content']
    }, children));
};
CreateButton.displayName = 'CreateButton';
export default CreateButton;
